module.exports = __webpack_public_path__ + "static/img/icon_play.e37ec67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/icon_play.png
// module id = O3ly
// module chunks = 1